import React from 'react';
import TabSelector from '../../../../shared/widgets/TabSelector/TabSelector';
import { useFilterContext } from 'ui-builder';
import { ProjectDetailsFilter } from 'nekst-api';
import { useProjectTypeHelper } from 'features/tasks-forms';

export default function ProjectTypeFilter() {
  const filterContext = useFilterContext<ProjectDetailsFilter>();

  const activeOption = filterContext.filterValue?.projectType;

  const projectTypeHelper = useProjectTypeHelper();

  return (
    <TabSelector
      activeOption={activeOption}
      onSelected={(value) => {
        filterContext.setFilterValue({
          ...filterContext.filterValue,
          projectType: value
        });
      }}
      options={[
        {
          value: undefined,
          label: 'All'
        },
        ...projectTypeHelper.getTypes()
          .map((item) => ({
            value: item,
            label: projectTypeHelper.getLabel(item)
          }))
      ]}
    />
  );
}
